export const ACTIVE = 'active';
export const PENDING_ACTIVATION = 'pendingActivation';
export const COVERAGE_REQUEST_SIGNED = 'coverageRequestSigned';
export const PENDING_CANCELLATION = 'pendingCancellation';
export const CANCELLED = 'cancelled';
